// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Nav {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 72px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 16px 8px;
  background-color: #f5f5f5; /* light grey nav background */
  color: #000; /* black text on light background */
  /* slower transitions for colors; width is no longer animated on the root (we animate the inner panel) */
  transition: background-color 420ms cubic-bezier(.22,.9,.33,1), color 320ms ease;
  will-change: background-color, color;
  cursor: pointer; /* entire nav is pressable to expand/collapse */
  z-index: 1000;
  box-shadow: 2px 0 8px rgba(0,0,0,0.06);
}

/* Proximity hover zone: an invisible area to the left of the nav
   so moving the mouse near the bar triggers :hover before touching it. */
.Nav::before {
  content: '';
  position: absolute;
  top: 0;
  left: -160px; /* extend further to start the darkening earlier */
  width: 160px;
  height: 100%;
  pointer-events: auto; /* capture pointer so :hover is triggered when near */
  background: transparent;
}

/* Sliding panel that visually expands. Animate transform (GPU-friendly) to avoid layout reflows. */
.Nav-panel {
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 33vw;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px 18px;
  transform: translateX(calc(-100% + 72px)); /* keep left 72px visible when closed */
  transition: transform 720ms cubic-bezier(.2,.8,.2,1), background-color 420ms ease, color 320ms ease;
  will-change: transform;
  pointer-events: none; /* disabled while closed so it doesn't steal clicks */
  overflow: hidden;
}

.Nav-panel-header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 8px;
}

/* Large variant of the color blocks used inside the expanded panel header */
.Nav-logo--blocks-large {
  height: 120px;
  width: auto;
  display: block;
  opacity: 0;
  transform: translateY(-8px) scale(.96);
  transition: opacity 360ms cubic-bezier(.2,.9,.2,1), transform 360ms cubic-bezier(.2,.9,.2,1);
  pointer-events: none;
}

/* Reveal the large blocks when the panel opens; position them near the top */
.Nav.open .Nav-logo--blocks-large {
  opacity: 1;
  transform: translateY(0) scale(1);
  pointer-events: auto;
}

/* On mobile, make the large image smaller and inline with the header text */
@media (max-width: 768px) {
  .Nav-logo--blocks-large {
    height: 40px;
    margin-right: 10px;
    opacity: 1; /* if panel opens on mobile, show it inline */
    transform: none;
  }
}

.Nav-panel-text {
  font-weight: 700;
  font-size: 1.05rem;
  color: inherit; /* will be white when panel darkens */
}

/* Ensure Nav-top and Nav-bottom remain visible and centered in the collapsed bar */
.Nav-top,
.Nav-bottom {
  width: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto; /* these should be interactive even when panel is closed */
  z-index: 1100; /* sit above the sliding panel */
}

/* Collapsed-only current-section label shown centered in the nav bar.
   Visible only when the nav is collapsed (not .open). Uses rotation so the text
   reads horizontally while fitting inside the narrow vertical bar. */
.Nav-current {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) rotate(-90deg);
  transform-origin: center;
  font-weight: 600;
  font-size: 0.95rem;
  color: inherit;
  white-space: nowrap;
  opacity: 1;
  pointer-events: none;
  transition: opacity 240ms ease, transform 420ms cubic-bezier(.2,.8,.2,1);
}

/* Hide the label when the nav is expanded */
.Nav.open .Nav-current {
  opacity: 0;
  transform: translate(-50%, -50%) rotate(-90deg) scale(0.9);
}

.Nav-text {
  /* keep the vertical styling but ensure it fits into the collapsed width */
  max-width: 48px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* When expanded, hide the vertical collapsed label and show the panel header title */
.Nav.open .Nav-top .Nav-text {
  opacity: 0;
  transform: rotate(180deg) translateX(-6px);
  transition: opacity 240ms ease, transform 320ms ease;
}

.Nav-panel-text {
  opacity: 0;
  transform: translateX(-6px);
  transition: opacity 320ms ease 200ms, transform 320ms ease 200ms;
}

.Nav.open .Nav-panel-text {
  opacity: 1;
  transform: translateX(0);
}

.Nav-login {
  background-color: hsla(150, 80%, 1%, 1);
}

.Nav-top {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  /* push the vertical brand label slightly down so it's fully visible */
  padding-top: 18px;
  position: relative;
  flex-direction: column; /* stack brand text and the blocks image vertically */
}

.Nav-logo {
  height: 40px;
  width: 40px;
  display: block;
}

/* color blocks image that appears under the brand label when the banner/nav is scrolled */
.Nav-logo--blocks {
  height: 34px;
  width: auto;
  display: block;
  opacity: 0;
  transform: translateY(-6px) rotate(-90deg);
  transform-origin: center;
  transition: opacity 260ms cubic-bezier(.2,.9,.2,1), transform 260ms cubic-bezier(.2,.9,.2,1);
  pointer-events: none;
}

/* Reveal when nav mirrors banner-scrolled */
.Nav.nav-scrolled .Nav-logo--blocks {
  opacity: 1;
  transform: translateY(0) rotate(-90deg);
  pointer-events: auto;
}

/* When the blocks are visible, add a small spacing so the vertical label doesn't overlap */
.Nav.nav-scrolled .Nav-text {
  margin-bottom: 6px;
}

.Nav-text {
  font-size: 0.95rem;
  font-weight: 600;
  /* Render the text vertically along the sidebar */
  writing-mode: vertical-rl;
  text-orientation: mixed;
  transform: rotate(180deg); /* flip to read top-to-bottom */
  letter-spacing: 0.06em;
  color: #000;
}

/* Desktop: keep the collapsed brand label hidden until the user scrolls.
   When \`.nav-scrolled\` is present the label will slide down into view. */
@media (min-width: 769px) {
  .Nav-text {
    opacity: 0;
    transform: translateY(-18px) rotate(180deg);
    transition: opacity 320ms cubic-bezier(.2,.9,.2,1), transform 320ms cubic-bezier(.2,.9,.2,1);
    will-change: opacity, transform;
  }

  .Nav.nav-scrolled .Nav-text {
    opacity: 1;
    transform: translateY(0) rotate(180deg);
  }

  /* ensure hover still reveals nav properly when expanded */
  .Nav:hover .Nav-text {
    color: #fff;
  }
}

/* Hovering the entire nav switches it to dark mode (black bg, white text/icons) */
.Nav:hover {
  background-color: #000;
  color: #fff;
}

.Nav:hover .Nav-text,
.Nav:hover .Nav-item {
  color: #fff;
}

.Nav:hover .Nav-toggle-inner,
.Nav:hover .Nav-toggle-inner::before,
.Nav:hover .Nav-toggle-inner::after {
  background: #fff; /* white hamburger lines on dark bg */
}

.Nav:hover .Nav-item:hover,
.Nav:hover .Nav-item:focus {
  background: rgba(255,255,255,0.06);
}

.Nav-links {
  margin-top: 16px;
  width: 100%;
  /* prepare for animated reveal: keep in flow but collapsed when hidden */
  max-height: 0;
  opacity: 0;
  transform: translateX(-10px);
  overflow: hidden;
  /* slower reveal so it follows the main expansion */
  transition: max-height 820ms cubic-bezier(.2,.8,.2,1), opacity 620ms ease 260ms, transform 620ms ease 260ms;
}

.Nav-bottom {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-bottom: 8px;
  /* raise the hamburger by moving it away from the bottom edge */
  margin-bottom: 20px;
}

/* Collapsed state: keep links present but hidden so they can animate */
.Nav .Nav-links {
  display: block;
  opacity: 0;
}


/* When open, the Nav-panel slides into view and receives the dark background */
.Nav.open {
  align-items: flex-start;
  cursor: default;
}

.Nav.open .Nav-panel {
  transform: translateX(0);
  background-color: #000;
  color: #fff;
  pointer-events: auto;
}

/* Make the hamburger/X lines visible on dark background when open */
.Nav.open .Nav-toggle-inner::before,
.Nav.open .Nav-toggle-inner::after {
  background: #fff;
}

.Nav.open .Nav-panel .Nav-text {
  /* hide the vertical brand label when the sidebar is expanded */
  display: none;
}

/* Hide the color blocks image when the nav is expanded so it doesn't appear
   inside the open panel. This applies to both desktop and mobile states. */
.Nav.open .Nav-logo--blocks {
  opacity: 0 !important;
  transform: translateY(-6px) rotate(-90deg);
  pointer-events: none;
}

.Nav.open .Nav-panel .Nav-links {
  /* reveal links with a smooth fade/slide as the panel expands */
  max-height: 1000px; /* large enough for content */
  opacity: 1;
  transform: translateX(0);
  margin-top: 24px;
  overflow: visible;
}

/* Center the nav links inside the expanded panel (both vertically and horizontally)
   and make them larger for emphasis. Visibility is controlled by the .open class so
   they remain visible even after hovering away. */
.Nav.open .Nav-panel .Nav-links {
  display: flex;
  flex-direction: column;
  /* left-align items inside the expanded panel */
  align-items: flex-start;
  justify-content: center;
  gap: 18px;
  margin: auto; /* centers vertically inside the panel */
  padding: 0 12px 0 36px; /* give extra left padding so text doesn't touch the edge */
}

/* Keep labels visible and interactive when the panel is open */
.Nav.open .Nav-panel .Nav-links .Nav-item-label {
  opacity: 1;
  transform: none;
}

.Nav.open .Nav-panel .Nav-links .Nav-item {
  pointer-events: auto;
}

.Nav.open .Nav-panel .Nav-links .Nav-item {
  /* Make link text much larger for emphasis in expanded state */
  font-size: 3.75rem; /* ~3x the previous 1.25rem */
  padding: 18px 14px;
  margin: 0;
  background: transparent;
  line-height: 1; /* keep tight lines for large type */
}

/* Per-item hover: arrow sits inline to the right of the label; description appears below */
.Nav-item {
  position: relative;
  display: inline-flex; /* keep label and arrow on one line */
  align-items: center;
  justify-content: flex-start; /* left-align label+arrow */
  gap: 8px;
  transition: transform 260ms cubic-bezier(.2,.8,.2,1), color 160ms ease;
  width: 100%; /* span the available width so left-alignment is consistent */
  text-align: left;
}

.Nav-item-label {
  display: inline-block;
}

.Nav-item-arrow {
  display: inline-block;
  margin-left: 12px; /* sits directly to the right of the label */
  opacity: 0;
  transform: translateX(-6px);
  transition: opacity 220ms ease, transform 260ms cubic-bezier(.2,.8,.2,1);
  font-size: 3.75rem; /* match the enlarged label when nav is open */
  line-height: 1;
  color: inherit;
}

.Nav-item-desc {
  position: absolute;
  left: 0; /* align with the left edge of the link text */
  top: calc(100% + 6px); /* place just below the link text */
  transform-origin: top left;
  transform: translateY(6px) rotateX(90deg);
  opacity: 0;
  transition: opacity 260ms ease, transform 320ms cubic-bezier(.2,.8,.2,1);
  font-size: 0.85rem;
  color: inherit; /* match current panel color */
  white-space: nowrap;
  background: rgba(0,0,0,0.12);
  padding: 6px 8px;
  border-radius: 6px;
  pointer-events: none;
  z-index: 1200;
}

.Nav.open .Nav-panel .Nav-links .Nav-item:hover,
.Nav.open .Nav-panel .Nav-links .Nav-item:focus {
  transform: translateY(-8px) scale(1.02);
}

.Nav.open .Nav-panel .Nav-links .Nav-item:hover .Nav-item-arrow,
.Nav.open .Nav-panel .Nav-links .Nav-item:focus .Nav-item-arrow {
  opacity: 1;
  transform: translateX(0);
}

.Nav.open .Nav-panel .Nav-links .Nav-item:hover .Nav-item-desc,
.Nav.open .Nav-panel .Nav-links .Nav-item:focus .Nav-item-desc {
  opacity: 1;
  transform: translateY(0) rotateX(0deg);
}

.Nav-item {
  color: inherit; /* follow panel/nav color so labels switch when panel darkens */
  text-decoration: none;
  padding: 10px 8px;
  border-radius: 6px;
  font-weight: 500;
  margin-bottom: 6px;
}

.Nav-item:hover,
.Nav-item:focus {
  background: rgba(0,0,0,0.04);
}

/* Hamburger / toggle */
.Nav-toggle {
  background: transparent;
  border: none;
  padding: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.Nav-toggle-box {
  width: 22px;
  height: 14px;
  display: inline-block;
  position: relative;
}

.Nav-toggle-inner,
.Nav-toggle-inner::before,
.Nav-toggle-inner::after {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  width: 100%;
  height: 2px;
  background: #000; /* dark hamburger lines on light bg */
  transition: transform 720ms cubic-bezier(.25,.75,.25,1), opacity 520ms ease;
}

.Nav-toggle-inner {
  top: 50%;
  transform: translateY(-50%);
}

.Nav-toggle-inner::before {
  top: -6px;
}

.Nav-toggle-inner::after {
  top: 6px;
}

/* Toggle animation when open */
.Nav.open .Nav-toggle-inner {
  background: transparent;
}

.Nav.open .Nav-toggle-inner::before {
  transform: translateY(6px) rotate(45deg);
}

.Nav.open .Nav-toggle-inner::after {
  transform: translateY(-6px) rotate(-45deg);
}

.Nav-link {
  text-decoration: none;
}

.Nav-button {
  background-color: var(--ocean-blue);
  color: var(--text-on-dark);
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.95rem;
  transition: background-color 0.2s ease, transform 0.12s ease;
}

.Nav-button:hover,
.Nav-button:focus {
  background-color: #005f8a; /* slightly darker sea blue */
  transform: translateY(-1px);
}

/* Responsive: collapse to top bar on small screens */
@media (max-width: 768px) {
  .Nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  }

  .Nav-item {
    display: block;
    color: inherit;
    text-decoration: none;
    padding: 10px 8px;
    border-radius: 6px;
    font-weight: 500;
    margin-bottom: 6px;
  }

  .Nav-item:hover,
  .Nav-item:focus {
    background: rgba(0,0,0,0.04);
  }

  /* Reset adjustments for small screen top bar layout */
  .Nav-top { padding-top: 0; }
  .Nav-bottom { margin-bottom: 0; }

  /* On small screens, disable the proximity zone so touches aren't intercepted */
  .Nav::before {
    pointer-events: none;
  }

  /* On small screens show the blocks inline to the left of the label */
  .Nav-logo--blocks {
    position: static;
    opacity: 1;
    transform: none; /* keep normal orientation on mobile */
    height: 28px;
    margin-right: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/Nav.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,aAAa;EACb,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB,EAAE,8BAA8B;EACzD,WAAW,EAAE,mCAAmC;EAChD,wGAAwG;EACxG,+EAA+E;EAC/E,oCAAoC;EACpC,eAAe,EAAE,+CAA+C;EAChE,aAAa;EACb,sCAAsC;AACxC;;AAEA;yEACyE;AACzE;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,YAAY,EAAE,kDAAkD;EAChE,YAAY;EACZ,YAAY;EACZ,oBAAoB,EAAE,qDAAqD;EAC3E,uBAAuB;AACzB;;AAEA,mGAAmG;AACnG;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC,EAAE,uCAAuC;EAClF,mGAAmG;EACnG,sBAAsB;EACtB,oBAAoB,EAAE,qDAAqD;EAC3E,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,WAAW;EACX,cAAc;EACd,UAAU;EACV,sCAAsC;EACtC,4FAA4F;EAC5F,oBAAoB;AACtB;;AAEA,6EAA6E;AAC7E;EACE,UAAU;EACV,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA,4EAA4E;AAC5E;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,UAAU,EAAE,6CAA6C;IACzD,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc,EAAE,qCAAqC;AACvD;;AAEA,mFAAmF;AACnF;;EAEE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB,EAAE,0DAA0D;EAChF,aAAa,EAAE,gCAAgC;AACjD;;AAEA;;qEAEqE;AACrE;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,+CAA+C;EAC/C,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,wEAAwE;AAC1E;;AAEA,4CAA4C;AAC5C;EACE,UAAU;EACV,0DAA0D;AAC5D;;AAEA;EACE,0EAA0E;EAC1E,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,qFAAqF;AACrF;EACE,UAAU;EACV,0CAA0C;EAC1C,oDAAoD;AACtD;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,gEAAgE;AAClE;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,sEAAsE;EACtE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB,EAAE,qDAAqD;AAC/E;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA,0FAA0F;AAC1F;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,UAAU;EACV,0CAA0C;EAC1C,wBAAwB;EACxB,4FAA4F;EAC5F,oBAAoB;AACtB;;AAEA,4CAA4C;AAC5C;EACE,UAAU;EACV,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA,2FAA2F;AAC3F;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;EACjD,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB,EAAE,+BAA+B;EAC1D,sBAAsB;EACtB,WAAW;AACb;;AAEA;yEACyE;AACzE;EACE;IACE,UAAU;IACV,2CAA2C;IAC3C,4FAA4F;IAC5F,+BAA+B;EACjC;;EAEA;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA,0DAA0D;EAC1D;IACE,WAAW;EACb;AACF;;AAEA,kFAAkF;AAClF;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;EAGE,gBAAgB,EAAE,qCAAqC;AACzD;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,wEAAwE;EACxE,aAAa;EACb,UAAU;EACV,4BAA4B;EAC5B,gBAAgB;EAChB,mDAAmD;EACnD,2GAA2G;AAC7G;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,+DAA+D;EAC/D,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;EACE,cAAc;EACd,UAAU;AACZ;;;AAGA,+EAA+E;AAC/E;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,WAAW;EACX,oBAAoB;AACtB;;AAEA,oEAAoE;AACpE;;EAEE,gBAAgB;AAClB;;AAEA;EACE,+DAA+D;EAC/D,aAAa;AACf;;AAEA;2EAC2E;AAC3E;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,+DAA+D;EAC/D,kBAAkB,EAAE,6BAA6B;EACjD,UAAU;EACV,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;kDAEkD;AAClD;EACE,aAAa;EACb,sBAAsB;EACtB,+CAA+C;EAC/C,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,YAAY,EAAE,wCAAwC;EACtD,sBAAsB,EAAE,2DAA2D;AACrF;;AAEA,+DAA+D;AAC/D;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,8DAA8D;EAC9D,kBAAkB,EAAE,6BAA6B;EACjD,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,cAAc,EAAE,oCAAoC;AACtD;;AAEA,2FAA2F;AAC3F;EACE,kBAAkB;EAClB,oBAAoB,EAAE,qCAAqC;EAC3D,mBAAmB;EACnB,2BAA2B,EAAE,2BAA2B;EACxD,QAAQ;EACR,sEAAsE;EACtE,WAAW,EAAE,6DAA6D;EAC1E,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB,EAAE,4CAA4C;EAC/D,UAAU;EACV,2BAA2B;EAC3B,wEAAwE;EACxE,kBAAkB,EAAE,8CAA8C;EAClE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO,EAAE,8CAA8C;EACvD,qBAAqB,EAAE,mCAAmC;EAC1D,0BAA0B;EAC1B,yCAAyC;EACzC,UAAU;EACV,wEAAwE;EACxE,kBAAkB;EAClB,cAAc,EAAE,8BAA8B;EAC9C,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;AACf;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;;EAEE,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,cAAc,EAAE,+DAA+D;EAC/E,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,WAAW;EACX,gBAAgB,EAAE,qCAAqC;EACvD,2EAA2E;AAC7E;;AAEA;EACE,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA,+BAA+B;AAC/B;EACE,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,4DAA4D;AAC9D;;AAEA;;EAEE,yBAAyB,EAAE,6BAA6B;EACxD,2BAA2B;AAC7B;;AAEA,qDAAqD;AACrD;EACE;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,sCAAsC;EACxC;;EAEA;IACE,cAAc;IACd,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA,sDAAsD;EACtD,WAAW,cAAc,EAAE;EAC3B,cAAc,gBAAgB,EAAE;;EAEhC,+EAA+E;EAC/E;IACE,oBAAoB;EACtB;;EAEA,qEAAqE;EACrE;IACE,gBAAgB;IAChB,UAAU;IACV,eAAe,EAAE,sCAAsC;IACvD,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":[".Nav {\n  position: fixed;\n  left: 0;\n  top: 0;\n  height: 100vh;\n  width: 72px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 8px;\n  background-color: #f5f5f5; /* light grey nav background */\n  color: #000; /* black text on light background */\n  /* slower transitions for colors; width is no longer animated on the root (we animate the inner panel) */\n  transition: background-color 420ms cubic-bezier(.22,.9,.33,1), color 320ms ease;\n  will-change: background-color, color;\n  cursor: pointer; /* entire nav is pressable to expand/collapse */\n  z-index: 1000;\n  box-shadow: 2px 0 8px rgba(0,0,0,0.06);\n}\n\n/* Proximity hover zone: an invisible area to the left of the nav\n   so moving the mouse near the bar triggers :hover before touching it. */\n.Nav::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -160px; /* extend further to start the darkening earlier */\n  width: 160px;\n  height: 100%;\n  pointer-events: auto; /* capture pointer so :hover is triggered when near */\n  background: transparent;\n}\n\n/* Sliding panel that visually expands. Animate transform (GPU-friendly) to avoid layout reflows. */\n.Nav-panel {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 33vw;\n  max-width: 480px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 20px 18px;\n  transform: translateX(calc(-100% + 72px)); /* keep left 72px visible when closed */\n  transition: transform 720ms cubic-bezier(.2,.8,.2,1), background-color 420ms ease, color 320ms ease;\n  will-change: transform;\n  pointer-events: none; /* disabled while closed so it doesn't steal clicks */\n  overflow: hidden;\n}\n\n.Nav-panel-header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding-bottom: 8px;\n}\n\n/* Large variant of the color blocks used inside the expanded panel header */\n.Nav-logo--blocks-large {\n  height: 120px;\n  width: auto;\n  display: block;\n  opacity: 0;\n  transform: translateY(-8px) scale(.96);\n  transition: opacity 360ms cubic-bezier(.2,.9,.2,1), transform 360ms cubic-bezier(.2,.9,.2,1);\n  pointer-events: none;\n}\n\n/* Reveal the large blocks when the panel opens; position them near the top */\n.Nav.open .Nav-logo--blocks-large {\n  opacity: 1;\n  transform: translateY(0) scale(1);\n  pointer-events: auto;\n}\n\n/* On mobile, make the large image smaller and inline with the header text */\n@media (max-width: 768px) {\n  .Nav-logo--blocks-large {\n    height: 40px;\n    margin-right: 10px;\n    opacity: 1; /* if panel opens on mobile, show it inline */\n    transform: none;\n  }\n}\n\n.Nav-panel-text {\n  font-weight: 700;\n  font-size: 1.05rem;\n  color: inherit; /* will be white when panel darkens */\n}\n\n/* Ensure Nav-top and Nav-bottom remain visible and centered in the collapsed bar */\n.Nav-top,\n.Nav-bottom {\n  width: 72px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: auto; /* these should be interactive even when panel is closed */\n  z-index: 1100; /* sit above the sliding panel */\n}\n\n/* Collapsed-only current-section label shown centered in the nav bar.\n   Visible only when the nav is collapsed (not .open). Uses rotation so the text\n   reads horizontally while fitting inside the narrow vertical bar. */\n.Nav-current {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%) rotate(-90deg);\n  transform-origin: center;\n  font-weight: 600;\n  font-size: 0.95rem;\n  color: inherit;\n  white-space: nowrap;\n  opacity: 1;\n  pointer-events: none;\n  transition: opacity 240ms ease, transform 420ms cubic-bezier(.2,.8,.2,1);\n}\n\n/* Hide the label when the nav is expanded */\n.Nav.open .Nav-current {\n  opacity: 0;\n  transform: translate(-50%, -50%) rotate(-90deg) scale(0.9);\n}\n\n.Nav-text {\n  /* keep the vertical styling but ensure it fits into the collapsed width */\n  max-width: 48px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* When expanded, hide the vertical collapsed label and show the panel header title */\n.Nav.open .Nav-top .Nav-text {\n  opacity: 0;\n  transform: rotate(180deg) translateX(-6px);\n  transition: opacity 240ms ease, transform 320ms ease;\n}\n\n.Nav-panel-text {\n  opacity: 0;\n  transform: translateX(-6px);\n  transition: opacity 320ms ease 200ms, transform 320ms ease 200ms;\n}\n\n.Nav.open .Nav-panel-text {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.Nav-login {\n  background-color: hsla(150, 80%, 1%, 1);\n}\n\n.Nav-top {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 100%;\n  /* push the vertical brand label slightly down so it's fully visible */\n  padding-top: 18px;\n  position: relative;\n  flex-direction: column; /* stack brand text and the blocks image vertically */\n}\n\n.Nav-logo {\n  height: 40px;\n  width: 40px;\n  display: block;\n}\n\n/* color blocks image that appears under the brand label when the banner/nav is scrolled */\n.Nav-logo--blocks {\n  height: 34px;\n  width: auto;\n  display: block;\n  opacity: 0;\n  transform: translateY(-6px) rotate(-90deg);\n  transform-origin: center;\n  transition: opacity 260ms cubic-bezier(.2,.9,.2,1), transform 260ms cubic-bezier(.2,.9,.2,1);\n  pointer-events: none;\n}\n\n/* Reveal when nav mirrors banner-scrolled */\n.Nav.nav-scrolled .Nav-logo--blocks {\n  opacity: 1;\n  transform: translateY(0) rotate(-90deg);\n  pointer-events: auto;\n}\n\n/* When the blocks are visible, add a small spacing so the vertical label doesn't overlap */\n.Nav.nav-scrolled .Nav-text {\n  margin-bottom: 6px;\n}\n\n.Nav-text {\n  font-size: 0.95rem;\n  font-weight: 600;\n  /* Render the text vertically along the sidebar */\n  writing-mode: vertical-rl;\n  text-orientation: mixed;\n  transform: rotate(180deg); /* flip to read top-to-bottom */\n  letter-spacing: 0.06em;\n  color: #000;\n}\n\n/* Desktop: keep the collapsed brand label hidden until the user scrolls.\n   When `.nav-scrolled` is present the label will slide down into view. */\n@media (min-width: 769px) {\n  .Nav-text {\n    opacity: 0;\n    transform: translateY(-18px) rotate(180deg);\n    transition: opacity 320ms cubic-bezier(.2,.9,.2,1), transform 320ms cubic-bezier(.2,.9,.2,1);\n    will-change: opacity, transform;\n  }\n\n  .Nav.nav-scrolled .Nav-text {\n    opacity: 1;\n    transform: translateY(0) rotate(180deg);\n  }\n\n  /* ensure hover still reveals nav properly when expanded */\n  .Nav:hover .Nav-text {\n    color: #fff;\n  }\n}\n\n/* Hovering the entire nav switches it to dark mode (black bg, white text/icons) */\n.Nav:hover {\n  background-color: #000;\n  color: #fff;\n}\n\n.Nav:hover .Nav-text,\n.Nav:hover .Nav-item {\n  color: #fff;\n}\n\n.Nav:hover .Nav-toggle-inner,\n.Nav:hover .Nav-toggle-inner::before,\n.Nav:hover .Nav-toggle-inner::after {\n  background: #fff; /* white hamburger lines on dark bg */\n}\n\n.Nav:hover .Nav-item:hover,\n.Nav:hover .Nav-item:focus {\n  background: rgba(255,255,255,0.06);\n}\n\n.Nav-links {\n  margin-top: 16px;\n  width: 100%;\n  /* prepare for animated reveal: keep in flow but collapsed when hidden */\n  max-height: 0;\n  opacity: 0;\n  transform: translateX(-10px);\n  overflow: hidden;\n  /* slower reveal so it follows the main expansion */\n  transition: max-height 820ms cubic-bezier(.2,.8,.2,1), opacity 620ms ease 260ms, transform 620ms ease 260ms;\n}\n\n.Nav-bottom {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  padding-bottom: 8px;\n  /* raise the hamburger by moving it away from the bottom edge */\n  margin-bottom: 20px;\n}\n\n/* Collapsed state: keep links present but hidden so they can animate */\n.Nav .Nav-links {\n  display: block;\n  opacity: 0;\n}\n\n\n/* When open, the Nav-panel slides into view and receives the dark background */\n.Nav.open {\n  align-items: flex-start;\n  cursor: default;\n}\n\n.Nav.open .Nav-panel {\n  transform: translateX(0);\n  background-color: #000;\n  color: #fff;\n  pointer-events: auto;\n}\n\n/* Make the hamburger/X lines visible on dark background when open */\n.Nav.open .Nav-toggle-inner::before,\n.Nav.open .Nav-toggle-inner::after {\n  background: #fff;\n}\n\n.Nav.open .Nav-panel .Nav-text {\n  /* hide the vertical brand label when the sidebar is expanded */\n  display: none;\n}\n\n/* Hide the color blocks image when the nav is expanded so it doesn't appear\n   inside the open panel. This applies to both desktop and mobile states. */\n.Nav.open .Nav-logo--blocks {\n  opacity: 0 !important;\n  transform: translateY(-6px) rotate(-90deg);\n  pointer-events: none;\n}\n\n.Nav.open .Nav-panel .Nav-links {\n  /* reveal links with a smooth fade/slide as the panel expands */\n  max-height: 1000px; /* large enough for content */\n  opacity: 1;\n  transform: translateX(0);\n  margin-top: 24px;\n  overflow: visible;\n}\n\n/* Center the nav links inside the expanded panel (both vertically and horizontally)\n   and make them larger for emphasis. Visibility is controlled by the .open class so\n   they remain visible even after hovering away. */\n.Nav.open .Nav-panel .Nav-links {\n  display: flex;\n  flex-direction: column;\n  /* left-align items inside the expanded panel */\n  align-items: flex-start;\n  justify-content: center;\n  gap: 18px;\n  margin: auto; /* centers vertically inside the panel */\n  padding: 0 12px 0 36px; /* give extra left padding so text doesn't touch the edge */\n}\n\n/* Keep labels visible and interactive when the panel is open */\n.Nav.open .Nav-panel .Nav-links .Nav-item-label {\n  opacity: 1;\n  transform: none;\n}\n\n.Nav.open .Nav-panel .Nav-links .Nav-item {\n  pointer-events: auto;\n}\n\n.Nav.open .Nav-panel .Nav-links .Nav-item {\n  /* Make link text much larger for emphasis in expanded state */\n  font-size: 3.75rem; /* ~3x the previous 1.25rem */\n  padding: 18px 14px;\n  margin: 0;\n  background: transparent;\n  line-height: 1; /* keep tight lines for large type */\n}\n\n/* Per-item hover: arrow sits inline to the right of the label; description appears below */\n.Nav-item {\n  position: relative;\n  display: inline-flex; /* keep label and arrow on one line */\n  align-items: center;\n  justify-content: flex-start; /* left-align label+arrow */\n  gap: 8px;\n  transition: transform 260ms cubic-bezier(.2,.8,.2,1), color 160ms ease;\n  width: 100%; /* span the available width so left-alignment is consistent */\n  text-align: left;\n}\n\n.Nav-item-label {\n  display: inline-block;\n}\n\n.Nav-item-arrow {\n  display: inline-block;\n  margin-left: 12px; /* sits directly to the right of the label */\n  opacity: 0;\n  transform: translateX(-6px);\n  transition: opacity 220ms ease, transform 260ms cubic-bezier(.2,.8,.2,1);\n  font-size: 3.75rem; /* match the enlarged label when nav is open */\n  line-height: 1;\n  color: inherit;\n}\n\n.Nav-item-desc {\n  position: absolute;\n  left: 0; /* align with the left edge of the link text */\n  top: calc(100% + 6px); /* place just below the link text */\n  transform-origin: top left;\n  transform: translateY(6px) rotateX(90deg);\n  opacity: 0;\n  transition: opacity 260ms ease, transform 320ms cubic-bezier(.2,.8,.2,1);\n  font-size: 0.85rem;\n  color: inherit; /* match current panel color */\n  white-space: nowrap;\n  background: rgba(0,0,0,0.12);\n  padding: 6px 8px;\n  border-radius: 6px;\n  pointer-events: none;\n  z-index: 1200;\n}\n\n.Nav.open .Nav-panel .Nav-links .Nav-item:hover,\n.Nav.open .Nav-panel .Nav-links .Nav-item:focus {\n  transform: translateY(-8px) scale(1.02);\n}\n\n.Nav.open .Nav-panel .Nav-links .Nav-item:hover .Nav-item-arrow,\n.Nav.open .Nav-panel .Nav-links .Nav-item:focus .Nav-item-arrow {\n  opacity: 1;\n  transform: translateX(0);\n}\n\n.Nav.open .Nav-panel .Nav-links .Nav-item:hover .Nav-item-desc,\n.Nav.open .Nav-panel .Nav-links .Nav-item:focus .Nav-item-desc {\n  opacity: 1;\n  transform: translateY(0) rotateX(0deg);\n}\n\n.Nav-item {\n  color: inherit; /* follow panel/nav color so labels switch when panel darkens */\n  text-decoration: none;\n  padding: 10px 8px;\n  border-radius: 6px;\n  font-weight: 500;\n  margin-bottom: 6px;\n}\n\n.Nav-item:hover,\n.Nav-item:focus {\n  background: rgba(0,0,0,0.04);\n}\n\n/* Hamburger / toggle */\n.Nav-toggle {\n  background: transparent;\n  border: none;\n  padding: 6px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.Nav-toggle-box {\n  width: 22px;\n  height: 14px;\n  display: inline-block;\n  position: relative;\n}\n\n.Nav-toggle-inner,\n.Nav-toggle-inner::before,\n.Nav-toggle-inner::after {\n  content: '';\n  display: block;\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background: #000; /* dark hamburger lines on light bg */\n  transition: transform 720ms cubic-bezier(.25,.75,.25,1), opacity 520ms ease;\n}\n\n.Nav-toggle-inner {\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.Nav-toggle-inner::before {\n  top: -6px;\n}\n\n.Nav-toggle-inner::after {\n  top: 6px;\n}\n\n/* Toggle animation when open */\n.Nav.open .Nav-toggle-inner {\n  background: transparent;\n}\n\n.Nav.open .Nav-toggle-inner::before {\n  transform: translateY(6px) rotate(45deg);\n}\n\n.Nav.open .Nav-toggle-inner::after {\n  transform: translateY(-6px) rotate(-45deg);\n}\n\n.Nav-link {\n  text-decoration: none;\n}\n\n.Nav-button {\n  background-color: var(--ocean-blue);\n  color: var(--text-on-dark);\n  border: none;\n  padding: 10px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  transition: background-color 0.2s ease, transform 0.12s ease;\n}\n\n.Nav-button:hover,\n.Nav-button:focus {\n  background-color: #005f8a; /* slightly darker sea blue */\n  transform: translateY(-1px);\n}\n\n/* Responsive: collapse to top bar on small screens */\n@media (max-width: 768px) {\n  .Nav {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: auto;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 16px;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.08);\n  }\n\n  .Nav-item {\n    display: block;\n    color: inherit;\n    text-decoration: none;\n    padding: 10px 8px;\n    border-radius: 6px;\n    font-weight: 500;\n    margin-bottom: 6px;\n  }\n\n  .Nav-item:hover,\n  .Nav-item:focus {\n    background: rgba(0,0,0,0.04);\n  }\n\n  /* Reset adjustments for small screen top bar layout */\n  .Nav-top { padding-top: 0; }\n  .Nav-bottom { margin-bottom: 0; }\n\n  /* On small screens, disable the proximity zone so touches aren't intercepted */\n  .Nav::before {\n    pointer-events: none;\n  }\n\n  /* On small screens show the blocks inline to the left of the label */\n  .Nav-logo--blocks {\n    position: static;\n    opacity: 1;\n    transform: none; /* keep normal orientation on mobile */\n    height: 28px;\n    margin-right: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
